/**
 * i18n bootstrap — Polish only for now (iter 35).
 *
 * The app currently ships PL-only, but the i18n plumbing is in place so the
 * next iteration can add EN by dropping a second JSON in `locales/` and
 * expanding the `resources` block. Components should gradually migrate from
 * hard-coded Polish strings to `useTranslation()` — no rush, keys are stable.
 *
 * Usage in a component:
 *   import { useTranslation } from "react-i18next";
 *   const { t } = useTranslation();
 *   <button>{t("common.save")}</button>
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pl from "./locales/pl.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
    },
    lng: "pl",
    fallbackLng: "pl",
    interpolation: { escapeValue: false }, // React already escapes
    react: { useSuspense: false },
  });

export default i18n;
